export const getCart = () => {
    const cart = localStorage.getItem("cart");
    return cart ? JSON.parse(cart) : {};
  };
  
  export const setCart = (cart) => {
    localStorage.setItem("cart", JSON.stringify(cart));
  };